
















































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import CreateFeeRequest from '@/models/Accounts/Shared/Fees/CreateFeeRequest';
import FeeFromTemplateForm from '@/components/Accounts/Shared/Fees/FeeFromTemplateForm.vue';
import FeeManualForm from '@/components/Accounts/Shared/Fees/FeeManualForm.vue';
import ProductType from "@/models/Products/ProductType";
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import CreateFeeType from "@/models/Accounts/Shared/Fees/CreateFeeType";

@Component({ name: 'FeeCreate', components: { FeeFromTemplateForm, FeeManualForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    CreateFeeType = CreateFeeType;
    selectedFeeType: string = '';
    request: CreateFeeRequest = new CreateFeeRequest();

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    currency: string;

    @Prop({required: true})
    productType: ProductType;

    mounted() {
        if (this.templatedFeesAvailable) {
            this.selectedFeeType = CreateFeeType.TemplatedFee;
        }
        else if (this.manualFeesAvailable) {
            this.selectedFeeType = CreateFeeType.ManualFee;
        }
    }

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.request = new CreateFeeRequest();
            if (!PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AdHocFees)) {
                this.request.subTransactionType = AuthModule.me.institution.config.feeTypes[0].value;
            }
            await SubTransactionTypesModule.getSubTransactionTypes();
        }
    }

    @Watch('selectedFeeType')
    async onSelectedFeeTypeChanged(val: string, oldVal: string) {
        if (val !== oldVal) {
            // Reset data when changing fee types
            this.request.subTransactionType = "";
            this.request.description = "";
        }
    }

    get templatedFeesAvailable() {
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductFees)) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountSettingsModule.productIssue.generalFeeSettings?.arbitraryFeesEnabled;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }

    get manualFeesAvailable() {
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AdHocFees)) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountSettingsModule.productIssue.generalFeeSettings?.manualFees;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    get productIssue() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountSettingsModule.productIssue;
        }
        else {
            return {};
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            this.request.amount.currency = this.currency;
            this.request.accountId = this.accountId;
            await DepositAccountModule.createFee(this.request);
        }
    }

}
